module.exports = __webpack_public_path__ + "img/2-s.c3d2ceb6.png";